import { keyframes } from 'styled-components';

/**
 * Using any here because there is an issue with reference
 * because some internals are not exported and it's too painful
 * to deal with with 0 benefits
 * https://typescript.tv/errors/#ts4023
 */
export const fadeIn: any = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
export const fadeOut: any = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

/**
 * `.text-color-contrast` paints its glyphs with `backdrop-filter`, which
 * samples nothing inside a backdrop root — and `opacity` creates one, even
 * once a forwards-filling animation has settled back on 1. Reveal anything
 * wrapping or carrying that class with this instead of `fadeIn`.
 */
export const revealWithoutOpacity: any = keyframes`
  from {
    visibility: hidden;
  }
  to {
    visibility: visible;
  }
`;
